import * as React from 'react';
import PropTypes from "prop-types";
import {
  Box,
  Card,
  CardContent,
  Typography
} from "@mui/material";
import {forwardRef} from "react";
import {getDateTimeStr, getLocalDateTimeStr} from "../utils/DateUtils";

const LevainRecipe = forwardRef(function LevainRecipe(props, printRef) {
  const {items, variant, elevation} = props

  function renderFlour(flourItem) {
    if (flourItem.weight > 0) {
      return (
        <Typography key={flourItem.id} sx={{fontSize: 14}} color="text.secondary">
          &nbsp; &nbsp; {flourItem.percent}% {flourItem.name} : {flourItem.weight}g
        </Typography>
      )
    }
    else {
      return null
    }
  }
  function renderLevainFermentTiming(levain) {
    if (levain.levainFermTimeStr.length === 0) {
      return null
    }
    return (
            <div>
              <Typography sx={{fontSize: 14, marginTop: 2, marginBottom: 0}} color="text.secondary" gutterBottom>
                Timing
              </Typography>
              <Typography sx={{fontSize: 12, marginLeft: 2}} gutterBottom>
                {`Estimated ${levain.levainFermPct}% rise time @ ${levain.levainFermTempF}°F: `}
                <Box component="span" fontWeight='800'>{levain.levainFermTimeStr}</Box>
              </Typography>
            </div>
    )
  }

  return (
        <Card elevation={elevation} variant={variant}>
          <CardContent id={'print-levain-card'} ref={printRef}>
          <Typography sx={{fontWeight: 600}} variant="h6" component={'div'}>
            {items.formName}
          </Typography>
          <Typography sx={{ fontSize: 10}}>
            Generated: {getLocalDateTimeStr()}
          </Typography>
          {items.createdAt ? (
              <Typography sx={{ fontSize: 10}}>{`Created: ${getDateTimeStr(new Date(items.createdAt))}`}</Typography>
          ) : null}
          {items.modifiedAt ? (
              <Typography sx={{ fontSize: 10}}>{`Last modified: ${getDateTimeStr(new Date(items.modifiedAt))}`}</Typography>
          ) : null}
          <Typography sx={{fontSize: 18, marginTop: 2}} component={'div'}>
             Levain Build ({items.levain.totalWeight}g @ {items.levain.water.percent}%H)
          </Typography>

          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            {items.levain.starterWeight}g
            : {items.levain.flourWeight}g
            : {items.levain.water.weight}g
            &nbsp; (starter : flour : water)
          </Typography>
          <Typography sx={{ fontSize: 12, marginLeft: 2, marginTop: -0.5, marginBottom: -0.25}} color="text.secondary" gutterBottom>
            Refresh Build
          </Typography>
          <Typography sx={{ fontSize: 12, marginLeft: 2, marginBottom: -0.25}} color="text.secondary" gutterBottom>
            #1 ({items.levain.refresh1.starterWeight}g:{items.levain.refresh1.flourWeight}g:{items.levain.refresh1.liquidWeight}g) Total {items.levain.refresh1.totalWeight}g
          </Typography>
          <Typography sx={{ fontSize: 12, marginLeft: 2}} color="text.secondary" gutterBottom>
            #2 ({items.levain.refresh2.starterWeight}g:{items.levain.refresh2.flourWeight}g:{items.levain.refresh2.liquidWeight}g) Total {items.levain.refresh2.totalWeight}g
          </Typography>

          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            Starter Seed : <span style={{fontWeight: 'bold'}}>{items.levain.starterWeight}g</span> ({items.levain.starterPct}% seed @ {items.levain.starterHydrationPct}%H)
          </Typography>
          <Typography sx={{ fontSize: 14 }} color="text.secondary">
            Flour Total: <span style={{fontWeight: 'bold'}}>{items.levain.flourWeight}g</span>
          </Typography>
          {
            items.levain.flour.map( flourItem => (
                    renderFlour(flourItem)
            ))
          }
          <Typography sx={{ fontSize: 14, marginTop: 1}} color="text.secondary" gutterBottom>
            Liquid: <span style={{fontWeight: 'bold'}}>{items.levain.water.weight}g</span>
          </Typography>

          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            Total Weight: <span style={{fontWeight: 'bold'}}>{items.levain.totalWeight}g</span>
          </Typography>
          {renderLevainFermentTiming(items.levain)}
        </CardContent>
    </Card>
    )
})

LevainRecipe.propTypes = {
  items: PropTypes.shape({
    formName: PropTypes.string,
    createdAt: PropTypes.number,
    modifiedAt: PropTypes.number,
    levain: PropTypes.shape( {
      starterPct: PropTypes.number,
      hydrationPct: PropTypes.number,
      starterHydrationPct: PropTypes.number,
      starterWeight: PropTypes.number,
      flourWeight: PropTypes.number,
      flour: PropTypes.arrayOf(PropTypes.shape({
        flourName: PropTypes.string,
        weight: PropTypes.number,
        percent: PropTypes.number
      })),
      water: PropTypes.shape({
        weight: PropTypes.number,
        percent: PropTypes.number
      }),
      totalWeight: PropTypes.number,
      pctOfDoughAsTotal: PropTypes.number,
      pctOfDoughAsPff: PropTypes.number,
      levainFermPct: PropTypes.number,
      levainFermTempF: PropTypes.string,
      levainFermTimeStr: PropTypes.string,
      refresh1: PropTypes.shape({
        flourWeight: PropTypes.number,
        liquidWeight: PropTypes.number,
        starterWeight: PropTypes.number,
        totalWeight: PropTypes.number,
      }),
      refresh2: PropTypes.shape({
        flourWeight: PropTypes.number,
        liquidWeight: PropTypes.number,
        starterWeight: PropTypes.number,
        totalWeight: PropTypes.number,
      })
    })
  }),
  visible: PropTypes.bool
}

export { LevainRecipe }